import moment from "moment-timezone";

let dataOS = [
  { name: "Windows Phone", value: "Windows Phone", version: "OS" },
  { name: "Windows", value: "Win", version: "NT" },
  { name: "iPhone", value: "iPhone", version: "OS" },
  { name: "iPad", value: "iPad", version: "OS" },
  { name: "Kindle", value: "Silk", version: "Silk" },
  { name: "Android", value: "Android", version: "Android" },
  { name: "PlayBook", value: "PlayBook", version: "OS" },
  { name: "BlackBerry", value: "BlackBerry", version: "/" },
  { name: "Macintosh", value: "Mac", version: "OS X" },
  { name: "Linux", value: "Linux", version: "rv" },
  { name: "Palm", value: "Palm", version: "PalmOS" },
];

let dataBrowser = [
  { name: "Chrome", value: "Chrome", version: "Chrome" },
  { name: "Firefox", value: "Firefox", version: "Firefox" },
  { name: "Safari", value: "Safari", version: "Version" },
  { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
  { name: "Opera", value: "Opera", version: "Opera" },
  { name: "BlackBerry", value: "CLDC", version: "CLDC" },
  { name: "Mozilla", value: "Mozilla", version: "Mozilla" },
];

export const COMPLETED_SESSION_STATUSES = [
  "sessionEnded",
  "paymentByPayer",
  "payment",
  "paymentStatusWait",
  "userSessionEnded",
];

export const STAGES_BEFORE_CAMERA_CHECK = [
  'start',
  'personalDetails',
  'signatureInitial',
  'signatureStart',
  'signatureCaptured',
  'idVerificationStart',
  'idVerificationFront',
  'idVerificationBack',
  'mobileVerificationIdCapture',
  'mobileVerificationIdCaptureBack',
  'mobileVerificationPersonalDetails',
  'mobileVerificationSignatureInitial',
  'mobileVerificationSignatureCreation',
  'sessionEnded',
  'cameraCheckStart',
  'KBAStart',
  'KBAInProgress',
  'KBAFails'
];

export const TIME_ZONES = [
  "Europe/Andorra",
  "Asia/Dubai",
  "Asia/Kabul",
  "Europe/Tirane",
  "Asia/Yerevan",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville", // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Antarctica/Mawson",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Cordoba",
  "America/Argentina/Salta",
  "America/Argentina/Jujuy",
  "America/Argentina/Tucuman",
  "America/Argentina/Catamarca",
  "America/Argentina/La_Rioja",
  "America/Argentina/San_Juan",
  "America/Argentina/Mendoza",
  "America/Argentina/San_Luis",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Ushuaia",
  "Pacific/Pago_Pago",
  "Europe/Vienna",
  "Australia/Lord_Howe",
  "Antarctica/Macquarie",
  "Australia/Hobart",
  "Australia/Currie",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Australia/Broken_Hill",
  "Australia/Brisbane",
  "Australia/Lindeman",
  "Australia/Adelaide",
  "Australia/Darwin",
  "Australia/Perth",
  "Australia/Eucla",
  "Asia/Baku",
  "America/Barbados",
  "Asia/Dhaka",
  "Europe/Brussels",
  "Europe/Sofia",
  "Atlantic/Bermuda",
  "Asia/Brunei",
  "America/La_Paz",
  "America/Noronha",
  "America/Belem",
  "America/Fortaleza",
  "America/Recife",
  "America/Araguaina",
  "America/Maceio",
  "America/Bahia",
  "America/Sao_Paulo",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Santarem",
  "America/Porto_Velho",
  "America/Boa_Vista",
  "America/Manaus",
  "America/Eirunepe",
  "America/Rio_Branco",
  "America/Nassau",
  "Asia/Thimphu",
  "Europe/Minsk",
  "America/Belize",
  "America/St_Johns",
  "America/Halifax",
  "America/Glace_Bay",
  "America/Moncton",
  "America/Goose_Bay",
  "America/Blanc-Sablon",
  "America/Toronto",
  "America/Nipigon",
  "America/Thunder_Bay",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Atikokan",
  "America/Winnipeg",
  "America/Rainy_River",
  "America/Resolute",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Swift_Current",
  "America/Edmonton",
  "America/Cambridge_Bay",
  "America/Yellowknife",
  "America/Inuvik",
  "America/Creston",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Dawson",
  "Indian/Cocos",
  "Europe/Zurich",
  "Africa/Abidjan",
  "Pacific/Rarotonga",
  "America/Santiago",
  "America/Punta_Arenas",
  "Pacific/Easter",
  "Asia/Shanghai",
  "Asia/Urumqi",
  "America/Bogota",
  "America/Costa_Rica",
  "America/Havana",
  "Atlantic/Cape_Verde",
  "America/Curacao",
  "Indian/Christmas",
  "Asia/Nicosia",
  "Asia/Famagusta",
  "Europe/Prague",
  "Europe/Berlin",
  "Europe/Copenhagen",
  "America/Santo_Domingo",
  "Africa/Algiers",
  "America/Guayaquil",
  "Pacific/Galapagos",
  "Europe/Tallinn",
  "Africa/Cairo",
  "Africa/El_Aaiun",
  "Europe/Madrid",
  "Africa/Ceuta",
  "Atlantic/Canary",
  "Europe/Helsinki",
  "Pacific/Fiji",
  "Atlantic/Stanley",
  "Pacific/Chuuk",
  "Pacific/Pohnpei",
  "Pacific/Kosrae",
  "Atlantic/Faroe",
  "Europe/Paris",
  "Europe/London",
  "Asia/Tbilisi",
  "America/Cayenne",
  "Africa/Accra",
  "Europe/Gibraltar",
  "America/Godthab",
  "America/Danmarkshavn",
  "America/Scoresbysund",
  "America/Thule",
  "Europe/Athens",
  "Atlantic/South_Georgia",
  "America/Guatemala",
  "Pacific/Guam",
  "Africa/Bissau",
  "America/Guyana",
  "Asia/Hong_Kong",
  "America/Tegucigalpa",
  "America/Port-au-Prince",
  "Europe/Budapest",
  "Asia/Jakarta",
  "Asia/Pontianak",
  "Asia/Makassar",
  "Asia/Jayapura",
  "Europe/Dublin",
  "Asia/Jerusalem",
  "Asia/Kolkata",
  "Indian/Chagos",
  "Asia/Baghdad",
  "Asia/Tehran",
  "Atlantic/Reykjavik",
  "Europe/Rome",
  "America/Jamaica",
  "Asia/Amman",
  "Asia/Tokyo",
  "Africa/Nairobi",
  "Asia/Bishkek",
  "Pacific/Tarawa",
  "Pacific/Enderbury",
  "Pacific/Kiritimati",
  "Asia/Pyongyang",
  "Asia/Seoul",
  "Asia/Almaty",
  "Asia/Qyzylorda",
  //'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Asia/Aqtobe",
  "Asia/Aqtau",
  "Asia/Atyrau",
  "Asia/Oral",
  "Asia/Beirut",
  "Asia/Colombo",
  "Africa/Monrovia",
  "Europe/Vilnius",
  "Europe/Luxembourg",
  "Europe/Riga",
  "Africa/Tripoli",
  "Africa/Casablanca",
  "Europe/Monaco",
  "Europe/Chisinau",
  "Pacific/Majuro",
  "Pacific/Kwajalein",
  "Asia/Yangon",
  "Asia/Ulaanbaatar",
  "Asia/Hovd",
  "Asia/Choibalsan",
  "Asia/Macau",
  "America/Martinique",
  "Europe/Malta",
  "Indian/Mauritius",
  "Indian/Maldives",
  "America/Mexico_City",
  "America/Cancun",
  "America/Merida",
  "America/Monterrey",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Chihuahua",
  "America/Ojinaga",
  "America/Hermosillo",
  "America/Tijuana",
  "America/Bahia_Banderas",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Africa/Maputo",
  "Africa/Windhoek",
  "Pacific/Noumea",
  "Pacific/Norfolk",
  "Africa/Lagos",
  "America/Managua",
  "Europe/Amsterdam",
  "Europe/Oslo",
  "Asia/Kathmandu",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Auckland",
  "Pacific/Chatham",
  "America/Panama",
  "America/Lima",
  "Pacific/Tahiti",
  "Pacific/Marquesas",
  "Pacific/Gambier",
  "Pacific/Port_Moresby",
  "Pacific/Bougainville",
  "Asia/Manila",
  "Asia/Karachi",
  "Europe/Warsaw",
  "America/Miquelon",
  "Pacific/Pitcairn",
  "America/Puerto_Rico",
  "Asia/Gaza",
  "Asia/Hebron",
  "Europe/Lisbon",
  "Atlantic/Madeira",
  "Atlantic/Azores",
  "Pacific/Palau",
  "America/Asuncion",
  "Asia/Qatar",
  "Indian/Reunion",
  "Europe/Bucharest",
  "Europe/Belgrade",
  "Europe/Kaliningrad",
  "Europe/Moscow",
  "Europe/Simferopol",
  "Europe/Kirov",
  "Europe/Astrakhan",
  "Europe/Volgograd",
  "Europe/Saratov",
  "Europe/Ulyanovsk",
  "Europe/Samara",
  "Asia/Yekaterinburg",
  "Asia/Omsk",
  "Asia/Novosibirsk",
  "Asia/Barnaul",
  "Asia/Tomsk",
  "Asia/Novokuznetsk",
  "Asia/Krasnoyarsk",
  "Asia/Irkutsk",
  "Asia/Chita",
  "Asia/Yakutsk",
  "Asia/Khandyga",
  "Asia/Vladivostok",
  "Asia/Ust-Nera",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Asia/Srednekolymsk",
  "Asia/Kamchatka",
  "Asia/Anadyr",
  "Asia/Riyadh",
  "Pacific/Guadalcanal",
  "Indian/Mahe",
  "Africa/Khartoum",
  "Europe/Stockholm",
  "Asia/Singapore",
  "America/Paramaribo",
  "Africa/Juba",
  "Africa/Sao_Tome",
  "America/El_Salvador",
  "Asia/Damascus",
  "America/Grand_Turk",
  "Africa/Ndjamena",
  "Indian/Kerguelen",
  "Asia/Bangkok",
  "Asia/Dushanbe",
  "Pacific/Fakaofo",
  "Asia/Dili",
  "Asia/Ashgabat",
  "Africa/Tunis",
  "Pacific/Tongatapu",
  "Europe/Istanbul",
  "America/Port_of_Spain",
  "Pacific/Funafuti",
  "Asia/Taipei",
  "Europe/Kiev",
  "Europe/Uzhgorod",
  "Europe/Zaporozhye",
  "Pacific/Wake",
  "America/New_York",
  "America/Detroit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Indiana/Indianapolis",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Chicago",
  "America/Indiana/Tell_City",
  "America/Indiana/Knox",
  "America/Menominee",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/North_Dakota/Beulah",
  "America/Denver",
  "America/Boise",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Juneau",
  "America/Sitka",
  "America/Metlakatla",
  "America/Yakutat",
  "America/Nome",
  "America/Adak",
  "Pacific/Honolulu",
  "America/Montevideo",
  "Asia/Samarkand",
  "Asia/Tashkent",
  "America/Caracas",
  "Asia/Ho_Chi_Minh",
  "Pacific/Efate",
  "Pacific/Wallis",
  "Pacific/Apia",
  "Africa/Johannesburg",
].map(function (s) {
  var name = s.replace(/_/g, " ") + " GMT" + moment.tz(s).format("Z");

  return {
    name: name,
    searchable: name.toLowerCase(),
    value: s,
  };
});

export const getCredentialAnalysisStatus = (session: any) => {
  if (!session || !session?.stage) {
    return {};
  }

  if (session.stage === "start") {
    return { text: "Not started", class: "" };
  }

  if (session.stage === "idVerificationFailed") {
    return { text: "Failed", class: "" };
  }

  if (
    [
      "idVerificationStart",
      "idVerificationFront",
      "mobileVerificationIdCapture",
      "mobileVerificationPersonalDetails",
      "mobileVerificationSignatureInitial",
      "mobileVerificationSignatureCreation",
    ].indexOf(session.stage) >= 0
  ) {
    return { text: "In progress", class: "" };
  }

  if (
    ["idVerificationBack", "mobileVerificationIdCaptureBack"].indexOf(
      session.stage
    ) >= 0
  ) {
    return { text: "Enhanced Analysis", class: "" };
  }

  return { text: "Passed", class: "" };
};

export const getQuizStatus = (session: any) => {
  if (!session || !session.stage) {
    return {};
  }
  if (
    [
      "start",
      "idVerificationFront",
      "idVerificationFailed",
      "mobileVerificationIdCapture",
      "mobileVerificationPersonalDetails",
      "mobileVerificationSignatureInitial",
      "mobileVerificationSignatureCreation",
      "personalDetails",
      "cameraCheckStart",
      "signatureInitial",
      "signatureStart",
      "signatureCaptured",
      "userInRoom",
      "officialInRoom",
      "checkPersonalDetail",
    ].indexOf(session.stage) >= 0
  ) {
    return { text: "Not started", class: "" };
  }

  if (session.stage === "KBAFails") {
    return { text: "Failed", class: "" };
  }

  if (
    [
      "idVerificationFront",
      "mobileVerificationIdCapture",
      "mobileVerificationPersonalDetails",
      "mobileVerificationSignatureInitial",
      "mobileVerificationSignatureCreation",
    ].indexOf(session.stage) >= 0
  ) {
    return { text: "In progress", class: "" };
  }

  return { text: "Passed", class: "" };
};

export const getDevice = (session?: any) => {
  let device = "";
  if (session?.principalDevice) {
    device =
      decodeOS(session?.principalDevice) +
      " " +
      decodeBrowser(session?.principalDevice);
  }
  return device;
};

const match = (string: any, data: any) => {
  let regex;
  let regexv;
  let match;
  let matches;
  let version: any;

  for (let i = 0; i < data.length; i += 1) {
    regex = new RegExp(data[i].value, "i");
    match = regex.test(string);

    if (match) {
      regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
      matches = string.match(regexv);
      version = "";

      if (matches && matches[1]) {
        matches = matches[1];
      }

      if (matches) {
        matches = matches.split(/[._]+/);

        for (let j = 0; j < matches.length; j += 1) {
          if (j === 0) {
            version += matches[j] + ".";
          } else {
            version += matches[j];
          }
        }
      } else {
        version = "0";
      }

      return [data[i].name, parseFloat(version)]
        .filter(function (o) {
          if (typeof o === "string" && o) {
            return true;
          }

          return version !== null && version !== undefined && !isNaN(version);
        })
        .join(" ");
    }
  }

  return null;
};

const decodeOS = (navigator: any) => {
  let str = Object.values(navigator).join(" ");

  return match(str, dataOS);
};

const decodeBrowser = (navigator: any) => {
  let str = Object.values(navigator).join(" ");

  return match(str, dataBrowser);
};

export const createUserLink = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security) +
    "#/upload-documents"
  );
};

export const createUserPaymentLink = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security) +
    "#/service-params/forward-to-payment-page"
  );
};

export const createSharedDocsAppLink = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security)
  );
};

export const createUserLinkForCopySessionInvite = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security) +
    "#"
  );
};

export const createObserverLinkForSessionInvite = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security) +
    "#/observer"
  );
};

export const createUserLinkForCopyDownloadPageLink = function (notaryAppLink: any, security: any) {
  return (
    notaryAppLink +
    "?" +
    generateSecurityCredentials(security) +
    "#/download"
  );
};

export const generateSecurityCredentials = function (securityParams: any) {
  if (!securityParams) {
    console.error("No security credentials provided!");

    return false;
  }

  return Object.keys(securityParams)
    .map(function (param) {
      return param + "=" + securityParams[param];
    })
    .join("&");
};

export const createOfficialLink = (notaryAppLink: any, security: any) => {
  return (
    notaryAppLink + "?" + generateSecurityCredentials(security) + "#/official"
  );
};

let onlineGap = 30 * 1000;

export const isUserOnline = (item: any, propName?: any) => {
  propName = propName || 'officialLastOnlineAt';

  if (!item || !item[propName] || !item[propName]._seconds) {
    return false;
  }

  return (+new Date() - item[propName]._seconds * 1000) < onlineGap;
}


var finishedAtSortFn = (a: any, b: any) => {
  if (!a.finishedAt) {
    return -1;
  }

  if (!b.finishedAt) {
    return 1;
  }

  if (a.finishedAt._seconds > b.finishedAt._seconds) {
    return -1;
  }

  if (a.finishedAt._seconds < b.finishedAt._seconds) {
    return 1;
  }

  return 0;
};

const scheduledAtSortFn = (a: any, b: any) => {
  if (a.scheduledAt._seconds > b.scheduledAt._seconds) {
    return 1;
  }

  if (a.scheduledAt._seconds < b.scheduledAt._seconds) {
    return -1;
  }

  return 0;
};

export const sortItems = (items: any) => {
  items.all.sort(scheduledAtSortFn);
  items.scheduled.sort(scheduledAtSortFn);
  items.completed.sort(finishedAtSortFn);
};

export const displayByStatus = (newStatus: any, setStatus: any) => setStatus(newStatus);

export const COMPLETED_STATUS = "completed"
export const CANCELLED_STATUS = "cancelled"
export const SCHEDULED_STATUS = "scheduled"
